import ApiService from '../services/api'
import {
    PayinService,
    PayoutService,
} from '../services/calc'


export const ACTIONS = {
    UPDATE_SUM: 'updateSum',
    SET_PAYLIST_ACTIVE_ITEM: 'setPaylistActiveItem',
    SET_CURRENCYLIST_ACTIVE_ITEM: 'setCurrencylistActiveItem',
    FETCH_PAYIN_PAYLIST: 'fetchPayinPaylist',
    FETCH_PAYIN_CURRENCYLIST: 'fetchPayinCurrencylist',
    FETCH_PAYOUT_PAYLIST: 'fetchPayoutPaylist',
    FETCH_PAYOUT_CURRENCYLIST: 'fetchPayoutCurrencylist',
    PAYIN_FETCH_RESULT: 'payinFetchResult',
    PAYOUT_FETCH_RESULT: 'payoutFetchResult',
    CLEAR_STATE: 'clearState',
}


export const MUTATIONS = {
    UPDATE_SUM: 'updateSum',
    SET_PAYLIST_ACTIVE_ITEM: 'setPaylistActiveItem',
    SET_CURRENCYLIST_ACTIVE_ITEM: 'setCurrencylistActiveItem',
    FETCH_PAYIN_PAYLIST_START: 'fetchPayinSetPayListLoading',
    FETCH_PAYIN_PAYLIST_END: 'fetchPayinSetPayList',
    FETCH_PAYIN_CURRENCYLIST_START: 'fetchPayinSetCurrencyListLoading',
    FETCH_PAYIN_CURRENCYLIST_END: 'fetchPayinSetCurrencyList',
    FETCH_PAYOUT_PAYLIST_START: 'fetchPayoutSetPayListLoading',
    FETCH_PAYOUT_PAYLIST_END: 'fetchPayoutSetPayList',
    FETCH_PAYOUT_CURRENCYLIST_START: 'fetchPayoutSetCurrencyListLoading',
    FETCH_PAYOUT_CURRENCYLIST_END: 'fetchPayoutSetCurrencyList',
    FETCH_RESULT_START: 'FetchResultStart',
    PAYIN_FETCH_RESULT_END: 'payinFetchResultEnd',
    PAYOUT_FETCH_RESULT_END: 'payoutFetchResultEnd',
    CLEAR_STATE: 'clearState',
}


const state = {
    prevSum: '',
    prevPayListActiveItem: null,
    prevCurrencyActiveItem: null,
    sum: '',
    payListActiveItem: null,
    currencyActiveItem: null,
    result: '',
    resultIsLoading: false,
    payListIsLoading: true,
    currencyListIsLoading: true,
    payin: {
        payList: [],
        currencyList: [],
    },
    payout: {
        payList: [],
        currencyList: [],
    },
}


const getters = {
    sum: ({ sum }) => sum,
    payListActiveItem: ({ payListActiveItem }) => payListActiveItem,
    currencyActiveItem: ({ currencyActiveItem }) => currencyActiveItem,
    result: ({ result }) => result,
    resultIsLoading: ({ resultIsLoading }) => resultIsLoading,
    payListIsLoading: ({ payListIsLoading }) => payListIsLoading,
    currencyListIsLoading: ({ currencyListIsLoading }) => currencyListIsLoading,
    payinPayList: ({ payin }) => payin.payList,
    payinCurrencyList: ({ payin }) => payin.currencyList,
    payoutPayList: ({ payout }) => payout.payList,
    payoutCurrencyList: ({ payout }) => payout.currencyList,
}


const actions = {
    [ACTIONS.UPDATE_SUM]({ commit }, sum) {
        commit(MUTATIONS.UPDATE_SUM, sum)
    },

    [ACTIONS.SET_PAYLIST_ACTIVE_ITEM]({ commit }, index) {
        commit(MUTATIONS.SET_PAYLIST_ACTIVE_ITEM, index)
    },

    [ACTIONS.SET_CURRENCYLIST_ACTIVE_ITEM]({ commit }, index) {
        commit(MUTATIONS.SET_CURRENCYLIST_ACTIVE_ITEM, index)
    },

    [ACTIONS.CLEAR_STATE]({ commit }) {
        commit(MUTATIONS.CLEAR_STATE)
    },

    // PAYIN
    [ACTIONS.PAYIN_FETCH_RESULT]({ commit, state }) {
        if (
            state.sum === state.prevSum &&
            state.payListActiveItem === state.prevPayListActiveItem &&
            state.currencyActiveItem === state.prevCurrencyActiveItem) {
            return null
        }

        const
            amount = state.sum,
            system = state.payin.payList[state.payListActiveItem],
            currency = state.payin.currencyList[state.currencyActiveItem]

        if (!amount || !system || !currency) return null

        commit(MUTATIONS.FETCH_RESULT_START)

        return PayinService.getResult({
            amount,
            system: system.key,
            currency: currency.key,
        })
            .then(({ data }) => {
                commit(MUTATIONS.PAYIN_FETCH_RESULT_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.FETCH_PAYIN_PAYLIST]({ commit, state }) {
        if (state.payin.payList.length > 0) return

        commit(MUTATIONS.FETCH_PAYIN_PAYLIST_START)

        ApiService.setHeaderLang()
        return PayinService.getPayList()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_PAYIN_PAYLIST_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.FETCH_PAYIN_CURRENCYLIST]({ commit, state }) {
        if (state.payin.currencyList.length > 0) return

        commit(MUTATIONS.FETCH_PAYIN_CURRENCYLIST_START)

        ApiService.setHeaderLang()
        return PayinService.getCurrencyList()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_PAYIN_CURRENCYLIST_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    // PAYOUT
    [ACTIONS.PAYOUT_FETCH_RESULT]({ commit, state }) {
        if (state.sum === state.prevSum && state.payListActiveItem === state.prevPayListActiveItem && state.currencyActiveItem === state.prevCurrencyActiveItem) return null

        const
            amount = state.sum,
            system = state.payout.payList[state.payListActiveItem],
            currency = state.payout.currencyList[state.currencyActiveItem]

        if (!amount || !system || !currency) return null

        commit(MUTATIONS.FETCH_RESULT_START)

        return PayoutService.getResult({
            amount,
            system: system.key,
            currency: currency.key,
        })
            .then(({ data }) => {
                commit(MUTATIONS.PAYOUT_FETCH_RESULT_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.FETCH_PAYOUT_PAYLIST]({ commit, state }) {
        if (state.payout.payList.length > 0) return

        commit(MUTATIONS.FETCH_PAYOUT_PAYLIST_START)

        ApiService.setHeaderLang()
        return PayoutService.getPayList()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_PAYOUT_PAYLIST_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.FETCH_PAYOUT_CURRENCYLIST]({ commit, state }) {
        if (state.payout.currencyList.length > 0) return

        commit(MUTATIONS.FETCH_PAYOUT_CURRENCYLIST_START)

        ApiService.setHeaderLang()
        return PayoutService.getCurrencyList()
            .then(({ data }) => {
                commit(MUTATIONS.FETCH_PAYOUT_CURRENCYLIST_END, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

}


const mutations = {
    [MUTATIONS.UPDATE_SUM](state, sum) {
        state.sum = sum
    },

    [MUTATIONS.SET_PAYLIST_ACTIVE_ITEM](state, index) {
        state.payListActiveItem = index
    },

    [MUTATIONS.SET_CURRENCYLIST_ACTIVE_ITEM](state, index) {
        state.currencyActiveItem = index
    },

    [MUTATIONS.CLEAR_STATE](state) {
        state.prevSum = ''
        state.prevPayListActiveItem = null
        state.prevCurrencyActiveItem = null
        state.sum = ''
        state.payListActiveItem = null
        state.currencyActiveItem = null
        state.result = ''
    },

    [MUTATIONS.FETCH_RESULT_START](state) {
        state.resultIsLoading = true
    },

    // PAYIN
    [MUTATIONS.PAYIN_FETCH_RESULT_END](state, { data }) {
        state.prevSum = state.sum
        state.prevPayListActiveItem = state.payListActiveItem
        state.prevCurrencyActiveItem = state.currencyActiveItem
        state.result = Math.floor(data.amount * 100) / 100
        state.resultIsLoading = false
    },

    [MUTATIONS.FETCH_PAYIN_PAYLIST_START](state) {
        state.payListIsLoading = true
    },

    [MUTATIONS.FETCH_PAYIN_PAYLIST_END](state, { data }) {
        state.payin.payList = Object.values(data)
        state.payListIsLoading = false
    },

    [MUTATIONS.FETCH_PAYIN_CURRENCYLIST_START](state) {
        state.currencyListIsLoading = true
    },

    [MUTATIONS.FETCH_PAYIN_CURRENCYLIST_END](state, { data }) {
        state.payin.currencyList = data
        state.currencyListIsLoading = false
    },

    // PAYOUT
    [MUTATIONS.PAYOUT_FETCH_RESULT_END](state, { data }) {
        state.prevSum = state.sum
        state.prevPayListActiveItem = state.payListActiveItem
        state.prevCurrencyActiveItem = state.currencyActiveItem
        state.result = Math.floor(data.response * 100) / 100
        state.resultIsLoading = false
    },

    [MUTATIONS.FETCH_PAYOUT_PAYLIST_START](state) {
        state.payListIsLoading = true
    },

    [MUTATIONS.FETCH_PAYOUT_PAYLIST_END](state, { data }) {
        state.payout.payList = data
        state.payListIsLoading = false
    },


    [MUTATIONS.FETCH_PAYOUT_CURRENCYLIST_START](state) {
        state.currencyListIsLoading = true
    },

    [MUTATIONS.FETCH_PAYOUT_CURRENCYLIST_END](state, { data }) {
        state.payout.currencyList = data
        state.currencyListIsLoading = false
    },

}


export default {
    state,
    getters,
    actions,
    mutations,
}
